/**
 * @generated SignedSource<<6269910d4d215ae8b65540f6591ec00a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditDatesList_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateRow_data">;
  readonly " $fragmentType": "PackageEditDatesList_data";
};
export type PackageEditDatesList_data$key = {
  readonly " $data"?: PackageEditDatesList_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditDatesList_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditDatesList_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateRow_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "c10043f65ddc97c247a6b3f187664884";

export default node;
